export default "__VITE_ASSET__ykzkA7ci__"